define('common/ko/fn/valueFromPromise',['knockout', 'bluebird'], function(ko, Promise) {

    /**
     * Use when your observable contains a promise and you want its value
     */
    ko.subscribable.fn.valueFromPromise = function() {

        var source = this,
            lastKnownValue = ko.observable(),
            proxy,
            subscription;

        proxy = ko.pureComputed(function() {

            var sourceValue = source();

            if (sourceValue && sourceValue.then) {
                return lastKnownValue();
            }

            lastKnownValue(sourceValue);

            return sourceValue;
        });

        proxy.subscribe(function() {

            subscription = source.subscribeAndExec(function(maybePromise) {

                if (maybePromise && maybePromise.then) {

                    maybePromise.then(function() {

                        if (maybePromise !== source()) {
                            return;
                        }

                        lastKnownValue(arguments[0]);

                    });
                }

            });

        }, null, 'awake');

        proxy.subscribe(function() {
            subscription.dispose();
        }, null, 'asleep');

        return proxy;

    };

});

